// The decoded subject only selects local state; the server still authenticates every request.
export const agentOwner = () => {
  try {
    const token = window.localStorage.getItem('access_token');
    if (!token) return null;
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const subject = JSON.parse(window.atob(encoded)).sub;
    return subject === undefined || subject === null ? null : String(subject);
  } catch (_) {
    return null;
  }
};

export const deliveryKeys = (owner, page) => ({
  thread: `alloficient.agent.thread.${encodeURIComponent(owner)}.${page || 'general'}`,
  pending: `alloficient.agent.pending.${encodeURIComponent(owner)}.${page || 'general'}`,
});

export const readPending = (key, owner) => {
  const raw = window.sessionStorage.getItem(key);
  if (!raw) return null;
  const request = JSON.parse(raw);
  if (request.owner !== owner || !request.key || !request.payload?.message) return null;
  return request;
};

export const turnFailureText = (turn) => {
  const outcome = turn.financial_outcome;
  if (outcome?.state === 'committed') {
    const receipts = outcome.receipts || [];
    const details = receipts.map((receipt) => (
      `${receipt.action === 'reverse' ? 'Reversed' : 'Applied'} ${receipt.operation.replace(/_/g, ' ')} (proposal ${receipt.proposal_id}; current status: ${receipt.current_status}).`
    )).join(' ');
    return `A financial change was committed, but I could not finish the explanation. ${details} Check the recorded result before requesting another change.${outcome.reconciliation_required ? ' Another effect still needs reconciliation.' : ''}`;
  }
  if (outcome?.state === 'verified_no_effect') {
    return 'I could not complete that turn. No financial changes were committed.';
  }
  return 'I could not complete that turn. Its financial outcome is not yet confirmed. Reconnect to check the recorded result before repeating the request.';
};

export const CONTACT_LOST_TEXT = 'I lost contact with that turn. Its outcome is not yet confirmed. Reconnect to check the recorded result before repeating the request.';
